export default function About() {
  return (
    <section
      id="bemutatkozas"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-6">Bemutatkozás</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A]">
              Egy XIX. századi villa,<br />
              <span className="italic">modern lélekkel.</span>
            </h2>
            <div className="hairline-short mt-10 mb-10" />
            <img
              src="/images/interior-1.jpg"
              alt="Villa Porcelaine belső tér"
              className="w-full aspect-[4/5] object-cover"
              data-testid="about-image"
            />
          </div>

          <div className="lg:col-span-6 lg:col-start-7 lg:pt-12">
            <p className="text-[#1A1A1A] text-xl md:text-2xl font-serif-display leading-snug mb-8">
              A CoworkingVilla a Villa Porcelaine eredeti, gondosan felújított
              terében működik – Keszthely belvárosában, a Balaton-parttól pár
              percre.
            </p>
            <div className="space-y-6 text-[#595959] text-base md:text-[17px] leading-relaxed">
              <p>
                Hiszünk benne, hogy a környezet alakítja a gondolkodást. Ezért
                magas belmagasságú szobákat, természetes faanyagokat, csendes
                tetőtéri zugokat és diszkrét tárgyalókat kínálunk – mindezt egy
                történelmi villa porcelán-fehér homlokzata mögött.
              </p>
              <p>
                Akár egyetlen mély-fókuszú délutánra, akár több hónapos
                projektre érkezel, a CoworkingVilla rugalmasan alkalmazkodik
                ritmusodhoz. Foglald le online, érkezz meg, dolgozz.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-8 border-t border-[#E5E0D8] pt-10">
              <div data-testid="stat-1">
                <div className="font-serif-display text-5xl md:text-6xl text-[#1A1A1A]">8–20h</div>
                <p className="eyebrow mt-2">Nyitvatartás</p>
              </div>
              <div data-testid="stat-2">
                <div className="font-serif-display text-5xl md:text-6xl text-[#1A1A1A]">5+</div>
                <p className="eyebrow mt-2">Foglalható egység</p>
              </div>
              <div data-testid="stat-3">
                <div className="font-serif-display text-5xl md:text-6xl text-[#1A1A1A]">1 perc</div>
                <p className="eyebrow mt-2">Sétára a Balatontól</p>
              </div>
              <div data-testid="stat-4">
                <div className="font-serif-display text-5xl md:text-6xl text-[#1A1A1A]">∞</div>
                <p className="eyebrow mt-2">Specialty kávé</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
